// Last-writer-wins per item is the domain's one function, so the device's
// mirror and the edge's merge cannot disagree; this wrapper only keeps the
// mirror's Map shape (the domain returns a key-sorted array).
import { compareUpdatedAt, mergeProgress as mergeDomain } from "@proef/domain";
import type { ProgressItem } from "./contract";

export { compareUpdatedAt };

export function mergeProgress(
  stored: Iterable<ProgressItem>,
  incoming: Iterable<ProgressItem>,
): Map<string, ProgressItem> {
  return new Map(mergeDomain([...stored], [...incoming]).map((item) => [item.key, item]));
}
